import { IconNames } from "@blueprintjs/icons";
import { RichMetricCard } from "in_queue/components/common/MetricCard";
import { ClusterProjectsBaseScenario } from "in_queue/hooks/useClusterProjectRows";
import { ClusterProjectRow } from "in_queue/types/clusterProjectRowType";
import { formatCosts } from "in_queue/utils/formatting";
import { Loading } from "types/loadingType";
import css from "./ClusterMetricCards.module.scss";

export const ClusterMetricCards: React.FC<{
    rows: Loading<ClusterProjectRow[]>;
    baseScenario: ClusterProjectsBaseScenario | undefined;
}> = ({ rows, baseScenario }) => {
    const isLoading = rows === "loading";
    const loadedRows = rows === "loading" ? [] : rows;

    const sumCosts = (rows: ReadonlyArray<ClusterProjectRow>) =>
        rows.reduce((total, row) => total + (row.sumAllocatedCost ?? 0), 0);

    const clusterCost: Loading<string> = isLoading
        ? "loading"
        : formatCosts(baseScenario ? sumCosts(loadedRows) : undefined);
    const trackedRows = loadedRows.filter((row) => row.isTracked);
    const trackedCost: Loading<string> = isLoading
        ? "loading"
        : formatCosts(baseScenario ? sumCosts(trackedRows) : undefined);
    const trackedCount: Loading<string> = isLoading
        ? "loading"
        : String(trackedRows.length);

    const scoredCount = loadedRows.filter(
        (row) => row.sumAllocatedCost !== undefined
    ).length;
    const baseLabel = baseScenario
        ? `Base scenario · ${scoredCount} projects`
        : "No base scenario yet";

    return (
        <div className={css["ClusterMetricCards"]}>
            <RichMetricCard
                icon={IconNames.UNLOCK}
                label="Tracked Projects"
                value={trackedCount}
                valueSuffix="in this cluster"
                description="Projects your team has unlocked for scenario analysis."
            />
            <RichMetricCard
                icon={IconNames.DOLLAR}
                label="Tracked Projects Cost"
                value={trackedCost}
                description={`${baseLabel} · Nira estimated thermal costs`}
            />
            <RichMetricCard
                icon={IconNames.LAYERS}
                label="Cluster Upgrade Cost"
                value={clusterCost}
                description={`${baseLabel} · Nira estimated thermal costs`}
            />
        </div>
    );
};
